import {useEffect, useId, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {NumberToPersianLetters} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {TimePicker} from "../../../components/timepicker/timepicker";
import {TimeFixToGoLayout} from "../../../components/techaran/date-convert";

export interface schoolClassInterface {
    id: number,
    title: string,
    selected: boolean,
}

export const AdminsAddEditCenterClassModal = (props: {
    active: boolean,
    closeHandler: any,
    isEdit: boolean,
    id: number,
    title: string,
    desc: string,
    teacher: string,
    price: number,
    maxParticipants: number,
    onDone: any,
    isWorkshop: boolean,
    allowedClasses: number[],
    hasExpiration: boolean,
    expiresAt: string,
    sessionCount: number,
    presentedAt: string,
}) => {
    const [title, setTitle] = useState('');
    const [desc, setDesc] = useState('');
    const [teacher, setTeacher] = useState('');
    const [price, setPrice] = useState('');
    const [max, setMax] = useState('');
    const [isWorkshop, setIsWorkshop] = useState(false);
    const [classes, setClasses] = useState([] as schoolClassInterface[]);
    const [hasExpiration, setHasExpiration] = useState(false);
    const [expiresAt, setExpiresAt] = useState({
        time: [0, 0, 0],
        date: '2000-01-01',
    });
    const [sessionCount, setSessionCount] = useState('1');
    const [presentedAt, setPresentedAt] = useState({
        time: [0, 0, 0],
        date: '2000-01-01',
    });
    const ids = {
        title: useId(),
        desc: useId(),
        teacher: useId(),
        price: useId(),
        max: useId(),
    };
    const [err, setErr] = useState({
        title: false,
        desc: false,
        teacher: false,
        price: false,
        max: false,
        sessionCount: false,
    });
    const fetchClasses = (allowedClasses: number[]) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/center/class/get-school-classes',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: schoolClassInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let lst: schoolClassInterface[] = d.list === null ? [] : d.list;
                for (let i = 0; i < lst.length; i++) {
                    const x = allowedClasses.findIndex(e => e === lst[i].id);
                    if (x > -1)
                        lst[i].selected = true;
                }
                setClasses(lst);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.isEdit;
        const _title = props.title;
        const _desc = props.desc;
        const _teacher = props.teacher;
        const _price = props.price;
        const _max = props.maxParticipants;
        const _isWorkshop = props.isWorkshop;
        const _allowedClasses = props.allowedClasses;
        const _hasExp = props.hasExpiration;
        const _expiresAt = props.expiresAt.split(" "); // 2000-01-01 00:00:00
        const _presentedAt = props.presentedAt.split(" "); // 2000-01-01 00:00:00
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            if (isEdit) {
                setSendSMS(false);
                setTitle(_title);
                setDesc(_desc);
                setTeacher(_teacher);
                setPrice(_price.toString());
                setMax(_max.toString());
                setIsWorkshop(_isWorkshop);
                fetchClasses(_allowedClasses);
                setHasExpiration(_hasExp);
                const t = _expiresAt[1].split(":");
                const t2 = _presentedAt[1].split(":");
                setExpiresAt({
                    date: _expiresAt[0],
                    time: [parseInt(t[0]), parseInt(t[1]), parseInt(t[2])],
                });
                setPresentedAt({
                    date: _presentedAt[0],
                    time: [parseInt(t2[0]), parseInt(t2[1]), parseInt(t2[2])],
                });
            } else {
                setTitle('');
                setDesc('');
                setPrice('');
                setTeacher('');
                setMax('');
                setIsWorkshop(false);
                fetchClasses([]);
                setHasExpiration(false);
                const today = new Date();
                const todayIso = today.toISOString().split('T')[0];
                setExpiresAt({
                    date: todayIso,
                    time: [0, 0, 0],
                });
                setPresentedAt({
                    date: todayIso,
                    time: [0, 0, 0],
                });
            }
            setErr({
                desc: false,
                price: false,
                teacher: false,
                title: false,
                max: false,
                sessionCount: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const [sendSMS, setSendSMS] = useState(true);
    const saveChanges = () => {
        const isEdit = props.isEdit;
        const id = props.id;
        const _title = title.trim();
        const _desc = desc.trim();
        const _price = parseInt(price.trim() === '' ? '0' : price.trim());
        const _max = parseInt(max.trim() === '' ? '0' : max.trim());
        const _teacher = teacher.trim();
        const _isWorkshop = isWorkshop;
        const _classesAllowed = [...classes];
        let classList: number[] = [];
        _classesAllowed.forEach(e => {
            if (e.selected)
                classList.push(e.id);
        });
        console.log(classList);
        const _hasExp = hasExpiration;
        const _time = expiresAt;
        const _expiresAt = TimeFixToGoLayout(`${_time.date} ${_time.time[0]}:${_time.time[1]}:${_time.time[2]}`);
        const _sendSMS = isEdit ? '0' : (sendSMS ? '1' : '0');
        const _sessionCount = parseInt(sessionCount === '' ? '0' : sessionCount);
        const _time2 = presentedAt;
        const _presentedAt = TimeFixToGoLayout(`${_time2.date} ${_time2.time[0]}:${_time2.time[1]}:${_time2.time[2]}`);
        let errors = {
            title: false,
            desc: false,
            teacher: false,
            price: false,
            max: false,
            sessionCount: false,
        };
        let stop = false;
        if (_title.length < 2) {
            stop = true;
            errors.title = true;
        }
        if (_desc.length < 2) {
            stop = true;
            errors.desc = true;
        }
        if (_price < 1) {
            stop = true;
            errors.price = true;
        }
        if (_teacher.length < 2) {
            stop = true;
            errors.teacher = true;
        }
        if (_max < 1) {
            stop = true;
            errors.max = true;
        }
        if (_sessionCount < 1) {
            stop = true;
            errors.sessionCount = true;
        }
        setErr(errors);
        if (stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/center/class/' + (isEdit ? 'edit' : 'add'),
            {
                id: id.toString(),
                title: _title,
                desc: _desc,
                teacher: _teacher,
                max: _max,
                price: _price,
                isWorkshop: _isWorkshop ? '1' : '0',
                classes: JSON.stringify(classList),
                hasExpiration: _hasExp ? '1' : '0',
                expiresAt: _expiresAt,
                sms: _sendSMS,
                sessionCount: _sessionCount,
                presentedAt: _presentedAt,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    isEdit ? 'کلاس موردنظر ویرایش شد.' : 'کلاس جدید اضافه شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-xxl" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>{props.isEdit ? 'ویرایش' : 'افزودن'} کلاس مرکز علمی</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-5">
                                    <label>تاریخ پایان ثبت‌نام:</label>
                                    <button className={"techaran-switch" + (hasExpiration ? ' active' : '')}
                                            onClick={() => setHasExpiration(v => !v)}>
                                        <i><b/></i>
                                        <span>
                                            دارای تاریخ و ساعت انقضا
                                            <em>دارای شمارش معکوس در بخش دانش‌آموزان.</em>
                                        </span>
                                    </button>
                                    {
                                        hasExpiration ?
                                            <TimePicker
                                                lang={'fa'}
                                                hour={expiresAt.time[0]}
                                                minute={expiresAt.time[1]}
                                                setState={(h: number, m: number) => setExpiresAt(v => {
                                                    let x = {...v};
                                                    x.time[0] = h;
                                                    x.time[1] = m;
                                                    return x;
                                                })}
                                                title={''}
                                                locked={false}
                                                onSave={() => {
                                                }}
                                                date={expiresAt.date}
                                                setDate={(d: string) => setExpiresAt(v => {
                                                    let x = {...v};
                                                    x.date = d.split(' ')[0];
                                                    return x;
                                                })}
                                                hasDate={true}
                                            /> : null
                                    }
                                    <div style={{height: 10}}/>
                                    {
                                        isWorkshop ?
                                            <>
                                                <label>تاریخ و ساعت برگزاری کارگاه:</label>
                                                <TimePicker
                                                    lang={'fa'}
                                                    hour={presentedAt.time[0]}
                                                    minute={presentedAt.time[1]}
                                                    setState={(h: number, m: number) => setPresentedAt(v => {
                                                        let x = {...v};
                                                        x.time[0] = h;
                                                        x.time[1] = m;
                                                        return x;
                                                    })}
                                                    title={''}
                                                    locked={false}
                                                    onSave={() => {
                                                    }}
                                                    date={presentedAt.date}
                                                    setDate={(d: string) => setPresentedAt(v => {
                                                        let x = {...v};
                                                        x.date = d.split(' ')[0];
                                                        return x;
                                                    })}
                                                    hasDate={true}
                                                />
                                                <div style={{height: 15}}/>
                                            </> : null
                                    }
                                    {
                                        isWorkshop ?
                                            null :
                                            <>
                                                <label>تعداد جلسات:</label>
                                                <input type="number"
                                                       className={"form-control" + (err.sessionCount ? ' is-invalid' : '')}
                                                       min={1}
                                                       value={sessionCount}
                                                       onChange={e => {
                                                           let t = e.currentTarget.value;
                                                           setSessionCount(t);
                                                           setErr(v => {
                                                               let x = {...v};
                                                               x.sessionCount = false;
                                                               return x;
                                                           });
                                                       }}
                                                />
                                                <div style={{height: 15}}/>
                                            </>
                                    }
                                    <label>کلاس‌های هدف:</label>
                                    {
                                        classes.map((c, i) =>
                                            <button
                                                key={"K29fjwEe_3fFjSk"+i}
                                                className={"techaran-checkbox" + (c.selected ? ' active' : '')}
                                                onClick={() => setClasses(v=>{
                                                    let x = [...v];
                                                    x[i].selected = !x[i].selected;
                                                    return x;
                                                })}>
                                                <i><CheckIcon/></i>
                                                <span>{c.title}</span>
                                            </button>
                                        )
                                    }
                                    {
                                        !props.isEdit ?
                                            <>
                                                <div style={{height: 15}}/>
                                                <button className={"techaran-switch" + (sendSMS ? ' active' : '')}
                                                        onClick={() => setSendSMS(v => !v)}>
                                                    <i><b/></i>
                                                    <span>
                                            ارسال پیامک
                                            <em>به دانش‌آموزان هدف اطلاع‌رسانی خواهد شد.</em>
                                        </span>
                                                </button>
                                            </> : null
                                    }
                                    <div style={{height: 20}}/>
                                </div>
                                <div className="col-lg-7">
                                    <label htmlFor={ids.title}>عنوان کلاس:</label>
                                    <input type="text"
                                           id={ids.title}
                                           className={"form-control" + (err.title ? ' is-invalid' : '')}
                                           value={title}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setTitle(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.title = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div className={"invalid-feedback " + (err.title ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 15}}/>
                                    <button className={"techaran-switch" + (isWorkshop ? ' active' : '')}
                                            onClick={() => setIsWorkshop(v => !v)}>
                                        <i><b/></i>
                                        <span>این یک کارگاه است.</span>
                                    </button>
                                    <div style={{height: 5}}/>
                                    <label htmlFor={ids.teacher}>مربی:</label>
                                    <input type="text"
                                           id={ids.teacher}
                                           className={"form-control" + (err.teacher ? ' is-invalid' : '')}
                                           value={teacher}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setTeacher(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.teacher = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div className={"invalid-feedback " + (err.teacher ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 15}}/>
                                    <label htmlFor={ids.max}>ظرفیت کلاس (نفر):</label>
                                    <input type="text"
                                           id={ids.max}
                                           className={"form-control" + (err.max ? ' is-invalid' : '')}
                                           value={max}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setMax(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.max = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div className={"invalid-feedback " + (err.max ? 'd-block' : 'd-none')}>
                                        لطفا یک عدد بیشتر از صفر وارد کنید.
                                    </div>
                                    <div style={{height: 15}}/>
                                    <label htmlFor={ids.price}>قیمت:</label>
                                    <input type="number"
                                           id={ids.price}
                                           className={"form-control" + (err.price ? ' is-invalid' : '')}
                                           value={price}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setPrice(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.price = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <span style={{
                                        display: 'block',
                                        color: '#0a53be',
                                        fontSize: 14,
                                        padding: '5px 5px'
                                    }}>{NumberToPersianLetters(price === '' ? 0 : parseInt(price)) + " تومان"}</span>
                                    <div className={"invalid-feedback " + (err.price ? 'd-block' : 'd-none')}>
                                        لطفا یک قیمت وارد نمایید.
                                    </div>
                                    <div style={{height: 10}}/>
                                    <label htmlFor={ids.desc}>درباه کلاس:</label>
                                    <textarea id={ids.desc}
                                              style={{minHeight: 100}}
                                              className={"form-control" + (err.desc ? ' is-invalid' : '')}
                                              value={desc}
                                              onChange={e => {
                                                  const t = e.currentTarget.value;
                                                  setDesc(t);
                                                  setErr(v => {
                                                      let x = {...v};
                                                      x.desc = false;
                                                      return x;
                                                  });
                                              }}
                                    />
                                    <div className={"invalid-feedback " + (err.desc ? 'd-block' : 'd-none')}>
                                        لطفا حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center" style={{gap: 10}}>
                                <button className="cancel-button" onClick={props.closeHandler}>
                                    <b>انصراف</b>
                                </button>
                                <button className="btn-pay" onClick={saveChanges}>
                                    <b>ذخیره کلاس</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};